import {
    SET_GENBA_AI_VIEW,
    SET_GENBA_AI_SELECTED_ACTION,
    SET_GENBA_AI_VIEW_DETAILS,
    SET_GENBA_AI_IS_OPEN,
    RESET_GENBA_AI_STATE
} from "./types";

export const setGenbaAIView = (view) => ({
    type: SET_GENBA_AI_VIEW,
    payload: view,
});

export const setGenbaAISelectedAction = (selectedAction) => ({
    type: SET_GENBA_AI_SELECTED_ACTION,
    payload: selectedAction,
});

export const setGenbaAIViewDetails = (viewDetails) => ({
    type: SET_GENBA_AI_VIEW_DETAILS,
    payload: viewDetails,
});

export const setGenbaAIIsOpen = (isOpen) => ({
    type: SET_GENBA_AI_IS_OPEN,
    payload: isOpen,
});

export const resetGenbaAIState = () => ({
    type: RESET_GENBA_AI_STATE,
});
